import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';
import { api } from '../../../lib/api.js';

export const Route = createFileRoute('/_auth/admin')({
  beforeLoad: async ({ context }: any) => {
    // Auth guard: manager+ (managers can access junk-review; admin/super_admin get full admin nav)
    // The _auth parent already checks authentication.
    try {
      const data = await api.get<{ user: { role: string } }>('/api/auth/me');
      const role = data.user.role;
      if (!['manager', 'admin', 'super_admin'].includes(role)) {
        throw redirect({ to: '/' });
      }
    } catch (err: any) {
      if (err?.redirect) throw err;
      throw redirect({ to: '/login' });
    }
  },
  component: () => <Outlet />,
});
